// contexts/EmpresaContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { fetchData, postData, putData, deleteData } from '../../services/Api';
import { useAlert } from '../geral/AlertContext';

const EmpresaContext = createContext();

export const useEmpresa = () => useContext(EmpresaContext);

export const EmpresaProvider = ({ children }) => {
    const [empresas, setEmpresas] = useState([]);
    const { showAlert } = useAlert(); // Access showAlert from AlertContext

    useEffect(() => {
        const fetchDataFromAPI = async () => {
            try {
                const result = await fetchData('/Empresa');
                setEmpresas(result);
            } catch (error) {
                console.error("Erro ao buscar empresas:", error);
            }
        };
        fetchDataFromAPI();
    }, []);

    const addEmpresa = async (empresa) => {
        try {
            const result = await postData('/Empresa', empresa);
            setEmpresas([...empresas, result]);
            showAlert('Empresa adicionada com sucesso!');
        } catch (error) {
            console.error("Erro ao adicionar empresa:", error);
            showAlert('Erro ao adicionar empresa!', 'danger');
        }
    };

    const updateEmpresa = async (empresa) => {
        try {
            const result = await putData('/Empresa', empresa);
            setEmpresas((empresas) =>
                empresas.map((e) => (e.id === result.id ? result : e))
            );
            showAlert('Empresa alterada com sucesso!');
        } catch (error) {
            console.error("Erro ao atualizar empresa:", error);
            showAlert('Erro ao alterar empresa!', 'danger');
        }
    };

    const deleteEmpresa = async (id) => {
        try {            
            await deleteData('/Empresa', { empresaId: id });
            setEmpresas(empresas.filter(e => e.id !== id));
            showAlert('Empresa excluída com sucesso!');
        } catch (error) {
            console.error("Erro ao excluir empresa:", error);
            showAlert('Erro ao excluir empresa!', 'danger');
        }
    };

    return (
        <EmpresaContext.Provider value={{ empresas, addEmpresa, updateEmpresa, deleteEmpresa }}>
            {children}
        </EmpresaContext.Provider>
    );
};
